module.exports = __webpack_public_path__ + "img/buy-icon7-en.3a29687.png";